// import React from "react";

// import {
//   CheckIcon,
//   ExclamationTriangleIcon,
//   MinusIcon
// } from "@patternfly/react-icons";

// import { compareMajorMinorVersions } from "shared/utils/versionUtils";

// export default function VersionStatus({ pkg }) {
//   if (!pkg.current) {
//     return (
//       <small>
//         <MinusIcon /> <b>{pkg.name}:</b> ...
//       </small>
//     );
//   }

//   if (!pkg.latest) {
//     return (
//       <small>
//         <b>{pkg.name}:</b> {pkg.current}
//       </small>
//     );
//   }

//   const cmp = compareMajorMinorVersions(
//     pkg.current,
//     pkg.latest
//   );

//   if (cmp < 0) {
//     return (
//       <small
//         style={{
//           color:
//             "var(--pf-t--global--text--color--status--warning--default)",
//         }}
//       >
//         <ExclamationTriangleIcon />{" "}
//         <b>{pkg.name}:</b> {pkg.current} {"<"} {pkg.latest}
//       </small>
//     );
//   }

//   return (
//     <small
//       style={{
//         color:
//           "var(--pf-t--global--text--color--status--success--default)",
//       }}
//     >
//       <CheckIcon />{" "}
//       <b>{pkg.name}:</b> {pkg.current}
//       {pkg.current !== pkg.latest && (
//         <> {"<"} {pkg.latest}</>
//       )}
//     </small>
//   );
// }

import React from "react";

import {
  CheckIcon,
  ExclamationTriangleIcon,
  MinusIcon
} from "@patternfly/react-icons";

import { getVersionStatus } from "shared/utils/versionUtils";

export default function VersionStatus({ pkg }) {
  if (!pkg.current) {
    return (
      <small>
        <MinusIcon /> <b>{pkg.name}:</b> ...
      </small>
    );
  }

  if (!pkg.latest) {
    return (
      <small>
        <b>{pkg.name}:</b> {pkg.current}
      </small>
    );
  }

  const status = getVersionStatus(
    pkg.current,
    pkg.latest
  );

  if (status === "outdated") {
    return (
      <small
        style={{
          color:
            "var(--pf-t--global--text--color--status--warning--default)",
        }}
      >
        <ExclamationTriangleIcon />{" "}
        <b>{pkg.name}:</b> {pkg.current} {"<"} {pkg.latest}
      </small>
    );
  }

  return (
    <small
      style={{
        color:
          "var(--pf-t--global--text--color--status--success--default)",
      }}
    >
      <CheckIcon />{" "}
      <b>{pkg.name}:</b> {pkg.current}
      {pkg.current !== pkg.latest && (
        <> {"<"} {pkg.latest}</>
      )}
    </small>
  );
}